// extracted by mini-css-extract-plugin
export default {"container":"K-4V4Oi_FrU05zPt6tTEF","crumb":"_3eTrs6sdW2MbPPefScR8hO"};